// import { Country } from '../../modules/shared/country';

// export interface Preferences {
//   storageCost: number;
//   marginEuro: number;
//   marginPercentage: number;
//   adminCosts: number;
//   reviewCosts: number;
//   warrantyFee: number;
//   interestRate: number;
//   commercialExpenses: number;
// }

// export interface CalculatorProps {
//   preferences: Preferences;
//   marketValue: number;
//   planedDelay: number;
//   refurbishingCosts: number;
//   country: country;
//   vatSpain?: 'rebu' | 'yes100Percent' | 'yes50Percent';
// }
function round50(value) {
  return Math.ceil(value / 50) * 50;
}

export class Calculator {
  constructor(props) {
    this.props = props;
    this.depreciation = 0.8;
  }

  setPlanedDelay(delay) {
    this.props.planedDelay = delay;
  }

  setMarketValue(value) {
    this.props.marketValue = value;
  }

  setRefurbishingCosts(cost) {
    this.props.refurbishingCosts = cost;
  }

  setVatSpain(value) {
    this.props.vatSpain = value;
  }

  getVat() {
    switch (this.props.country) {
      case 'FR':
        return 1.2;
      case 'IT':
        return 1.22;
      case 'DE':
        return 1.19;
      case 'PT':
        return 1.23;
      case 'NL':
      case 'ES':
        return 1.21;
      default:
        return 1.2;
    }
  }

  getStorageCostTaxFree() {
    const { storageCost } = this.props.preferences;
    return storageCost * this.props.planedDelay;
  }

  getStorageCostWithTax() {
    return this.getStorageCostTaxFree() * this.props.planedDelay;
  }

  getCommercialExpenses() {
    const { commercialExpenses } = this.props.preferences;
    return (commercialExpenses / 100) * this.getValueAfterPlanedDelay();
  }

  getMargin() {
    const { marginPercentage, marginEuro } = this.props.preferences;
    return Math.max((marginPercentage / 100) * this.getValueAfterPlanedDelay(), marginEuro);
  }

  getVatOnMargin() {
    return (
      (this.getMargin() + Math.round(this.getFinancialCost(), 2) + Math.round(this.getGlobalCost(), 2)) *
      (this.getVat() - 1)
    );
  }

  getGlobalCost() {
    const { adminCosts, reviewCosts, warrantyFee } = this.props.preferences;
    return this.getStorageCostTaxFree() + this.getCommercialExpenses() + adminCosts + reviewCosts + warrantyFee;
  }

  getValueAfterPlanedDelay() {
    return this.props.marketValue * (1 - (this.depreciation / 3000) * this.props.planedDelay);
  }

  getFinancialCost() {
    const { adminCosts, reviewCosts, warrantyFee, storageCost, interestRate } = this.props.preferences;
    const cash =
      this.getValueAfterPlanedDelay() -
      adminCosts -
      reviewCosts -
      warrantyFee -
      storageCost * this.props.planedDelay -
      this.getCommercialExpenses();
    return (((cash * interestRate) / 100) * this.props.planedDelay) / 365;
  }

  getTradeIn() {
    return round50(
      Math.max(
        this.getValueAfterPlanedDelay() -
          this.getGlobalCost() -
          this.getFinancialCost() -
          this.getVatOnMargin() -
          this.getMargin(),
        0,
      ),
    );
  }

  getTaxExcludedVat() {
    switch (this.props.country) {
      case 'FR':
        return 0.8;
      case 'IT':
        return 0.78;
      case 'DE':
        return 1.19;
      case 'PT':
        return 0.77;
      case 'ES':
        return 0.79;
      default:
        return 1;
    }
  }
}
